import { CtrFilingStatus } from 'app/modules/fincenCtr/enums';
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';

export const CTR_FILING_STATUS_KEYS = {
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_FILE: 'READY_TO_FILE',
  SUBMITTING: 'SUBMITTING',
  SUBMISSION_ACCEPTED: 'SUBMISSION_ACCEPTED',
  SUBMISSION_SUCCESSFUL: 'SUBMISSION_SUCCESSFUL',
  SUBMISSION_FAILED: 'SUBMISSION_FAILED',
} as const;

export type CtrFilingStatusBucket = ValueOf<typeof CTR_FILING_STATUS_KEYS>;

export const CTR_FILING_STATUS_BUCKET_LABEL: Record<
  CtrFilingStatusBucket,
  string
> = {
  [CTR_FILING_STATUS_KEYS.IN_PROGRESS]: 'In progress',
  [CTR_FILING_STATUS_KEYS.READY_TO_FILE]: 'Ready to file',
  [CTR_FILING_STATUS_KEYS.SUBMITTING]: 'Submitting',
  [CTR_FILING_STATUS_KEYS.SUBMISSION_ACCEPTED]: 'Submission accepted',
  [CTR_FILING_STATUS_KEYS.SUBMISSION_SUCCESSFUL]: 'Submission successful',
  [CTR_FILING_STATUS_KEYS.SUBMISSION_FAILED]: 'Submission failed',
};

export const CTR_FILING_STATUS_OPTIONS: U21SelectOptionProps<CtrFilingStatusBucket>[] =
  [
    CTR_FILING_STATUS_KEYS.IN_PROGRESS,
    CTR_FILING_STATUS_KEYS.READY_TO_FILE,
    CTR_FILING_STATUS_KEYS.SUBMITTING,
    CTR_FILING_STATUS_KEYS.SUBMISSION_ACCEPTED,
    CTR_FILING_STATUS_KEYS.SUBMISSION_SUCCESSFUL,
    CTR_FILING_STATUS_KEYS.SUBMISSION_FAILED,
  ].map((i) => ({ text: CTR_FILING_STATUS_BUCKET_LABEL[i], value: i }));

export const BE_FE_CTR_STATUS_MAPPING: Record<
  CtrFilingStatus,
  CtrFilingStatusBucket
> = {
  [CtrFilingStatus.PENDING]: CTR_FILING_STATUS_KEYS.IN_PROGRESS,
  [CtrFilingStatus.PREFILING_VALIDATION_FAILED]:
    CTR_FILING_STATUS_KEYS.IN_PROGRESS,
  [CtrFilingStatus.PREFILING_VALIDATION_SUCCESS]:
    CTR_FILING_STATUS_KEYS.IN_PROGRESS,
  [CtrFilingStatus.READY_TO_FILE]: CTR_FILING_STATUS_KEYS.READY_TO_FILE,
  [CtrFilingStatus.SENDING_TO_FINCEN]: CTR_FILING_STATUS_KEYS.SUBMITTING,
  [CtrFilingStatus.ACCEPTED_BY_FINCEN]:
    CTR_FILING_STATUS_KEYS.SUBMISSION_ACCEPTED,
  [CtrFilingStatus.ACCEPTED_WITH_WARNINGS]:
    CTR_FILING_STATUS_KEYS.SUBMISSION_ACCEPTED,
  [CtrFilingStatus.FILING_SUCCESS]:
    CTR_FILING_STATUS_KEYS.SUBMISSION_SUCCESSFUL,
  [CtrFilingStatus.REJECTED_BY_FINCEN]:
    CTR_FILING_STATUS_KEYS.SUBMISSION_FAILED,
  [CtrFilingStatus.FILING_FAILED]: CTR_FILING_STATUS_KEYS.SUBMISSION_FAILED,
};

// Inverse of BE_FE: bucket → BE statuses. Used to expand a user's bucket pick
// into the raw statuses sent to the BE.
export const FE_BE_CTR_STATUS_MAPPING: Record<
  CtrFilingStatusBucket,
  CtrFilingStatus[]
> = Object.entries(BE_FE_CTR_STATUS_MAPPING).reduce<
  Record<CtrFilingStatusBucket, CtrFilingStatus[]>
>(
  (acc, [be, fe]: [CtrFilingStatus, CtrFilingStatusBucket]) => {
    acc[fe].push(be);
    return acc;
  },
  {
    [CTR_FILING_STATUS_KEYS.IN_PROGRESS]: [],
    [CTR_FILING_STATUS_KEYS.READY_TO_FILE]: [],
    [CTR_FILING_STATUS_KEYS.SUBMITTING]: [],
    [CTR_FILING_STATUS_KEYS.SUBMISSION_ACCEPTED]: [],
    [CTR_FILING_STATUS_KEYS.SUBMISSION_SUCCESSFUL]: [],
    [CTR_FILING_STATUS_KEYS.SUBMISSION_FAILED]: [],
  },
);
